import {
  object,
  string,
} from 'yup';

export const naturalPersonSearchValidationSchema = object().shape({
  firstName: string().required().min(2).label('First Name'),
  lastName: string().required().min(2).label('Last Name'),
});

export const legalEntitySearchValidationSchema = object().shape({
  fullName: string().required().min(3).label('Company Name'),
});


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/validation-schemas/watchListEntityEntrySearchValidationSchema.js